var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "file-upload_2",
    d: "M11 6.25V2H4.75C4.33437 2 4 2.33437 4 2.75V17.25C4 17.6656 4.33437 18 4.75 18H15.25C15.6656 18 16 17.6656 16 17.25V7H11.75C11.3375 7 11 6.6625 11 6.25ZM13.0369 13.0003H11V15.5003C11 15.7766 10.7762 16.0003 10.5 16.0003H9.5C9.22375 16.0003 9 15.7766 9 15.5003V13.0003H6.96312C6.51688 13.0003 6.29406 12.46 6.61094 12.1453L9.62406 9.15469C9.83187 8.94812 10.1675 8.94812 10.3753 9.15469L13.3884 12.1453C13.7056 12.46 13.4831 13.0003 13.0369 13.0003ZM15.7812 5.28125L12.7219 2.21875C12.5813 2.07812 12.3906 2 12.1906 2H12V6H16V5.80938C16 5.6125 15.9219 5.42188 15.7812 5.28125Z",
    fill: "#1271B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.feeccbf9b32f02dd44c55320a147f162.svg";
export { ForwardRef as ReactComponent };